export default __webpack_public_path__ + "static/media/rusbath4.e72152ab.jpeg";